// extracted by mini-css-extract-plugin
module.exports = {"button":"MyButton_button__3weIW","icon":"MyButton_icon__2h8Mw"};